// var data_main = require("./global_var");
// var DATA = data_main.data;
var data_file = String(document.getElementById('condData').getAttribute('key'));
var data_string = String("./data/" + data_file + '.json');

var data_aux = require("./global_var");
var hyphen_data = data_aux.hyphenData;
// convert hyphen_data to dictionary
let hyphen_dict = {};
for (let i = 0; i < hyphen_data.length; i++) {
    hyphen_dict[hyphen_data[i].Condition] = hyphen_data[i].ConditionHyphen;
}

const {
    curr_survey,
    survey_dict
} = require("./survey_dict");

// time period object consumed by clean_data_export.js
let tObj = {
    T1: survey_dict[curr_survey].t1,
    T2: survey_dict[curr_survey].t2,
};

if(survey_dict[curr_survey].t3) {
   tObj.T3 = survey_dict[curr_survey].t3;
}

let currTitle = curr_survey.toUpperCase();
// console.log(currTitle);

var {
    isExtraSmall,
    isSmall,
    isMedium,
    isLarge
} = require("./lib/breakpoints");
var makeTranslate = require("./lib/makeTranslate");
var debounce = require("./lib/debounce");
var classify = require("./lib/classify");
var formatStyle = require("./lib/formatStyle");
var export_data = require("./lib/export_data");
var saveAs = require('file-saver');
var cleanDataforExport = require('./lib/clean_data_export');

var d3 = {
    ...require("d3-axis/dist/d3-axis.min"),
    ...require("d3-scale/dist/d3-scale.min"),
    ...require("d3-selection/dist/d3-selection.min"),
    ...require("d3-shape/dist/d3-shape.min"),
    ...require("d3-collection/dist/d3-collection"),
    ...require("d3-textwrap/build/d3-textwrap.min"),
    ...require("d3-fetch/dist/d3-fetch"),
    ...require("d3-array/dist/d3-array.min")
};

var line = d3.line();

var barHeight = 40;
var valueGap = 6;

// var ticksX = 4;
var roundTicksFactor = 5;


//re-render chart on resize
window.addEventListener("resize", debounce(renderConditionGraphic));

function renderConditionGraphic() {

    var barGap = 9;
    var labelPadding = 1;
    var labelWidth = 90 + (labelPadding * 2);
    var labelHeight = 100;
    var labelMargin = 9;
    var margins;

    /// Style for the LARGE breakpoint only
    if (isLarge.matches) {
        labelWidth = 104 + (labelPadding * 2);
        barGap = 5;
    }
        
    //style for all other breakpoints
    margins = {
        top: 0,
        right: 40,
        bottom: 20,
        left: labelWidth + labelMargin
    };

    d3.json(data_string).then(function (DATA) {

        // console.log(DATA)
        if(curr_survey === "nrsa1819"){
            DATA = DATA.filter(d=>d.Subpopulation.includes("NATIONAL"))
        } else {
            DATA = DATA.filter(d=>d.Subpopulation.includes("National"))
        }
        // this is used later to alert the user if one of the indicators listed
        // in the text file is misspelled
        //Set finds the unique values in the array
        valid_indicators = [...new Set(DATA.map(d => {
            return d.IndicatorPL;
        }))];

        sortedData = d3.nest()
            .key(function (d) {
                return d.IndicatorPL;
            })
            .sortValues(function (a, b) {
                return (a.CatCondSort - b.CatCondSort);
            })
            .entries(DATA);

        sortedData = sortedData.map(function (d) {
            d.filteredValues = d.values.filter(function (j) {
                return j.CatCondBreakout == "Displayed";
            });
            return d;
        });

        // console.log('sortedData', sortedData);

        var latest_time_period,
            time_periods = [];
        // determine the latest time period available
        for (var i = 1; i < 4; i++) {
            if (sortedData[0].filteredValues[0][`Est.P.T${i}.Cond`]) {
                time_periods.push(i);
                latest_time_period = i;
            }
        }

        var valueColumn = `Est.P.T${latest_time_period}.Cond`,
            startRangeColumn = `LCB.P.T${latest_time_period}.Cond`,
            endRangeColumn = `UCB.P.T${latest_time_period}.Cond`,
            labelColumn = "CatCondPL";


        var containers = document.querySelectorAll(".conditionChartContainer");
        // console.log("conditiongraphic:", containers);

        // Calculate actual chart dimensions
        var chartWidth = containers[0].offsetWidth - margins.left - margins.right;
        var ticksX = chartWidth < 300 ? 3 : 4;

        //clear for redraw
        var containerElements = d3.selectAll(containers);
        // console.log("containerElements: ", containerElements._groups[0]);
        containerElements.html("");

        containerElements.each(function () {
            // console.log("conditiongraphic this: ", this);
            // console.log("conditiongraphic this",this.id);

            var indicator = this.id;
            // let downloadTitle = tempDownloadTitle.replace("Indicator", indicator);

            if (!valid_indicators.includes(indicator)) {
                console.log(indicator)
                d3.select(this)
                    .append("text")
                    .text('THE INDICATOR DATA_KEY DOES NOT MATCH THE DATA FILE')
            } else {
                // console.log('indicator', indicator)
                // console.log('data by indicator', sortedData.filter(d => d.key == indicator))
                var dataTemp = sortedData.filter(d => d.key == indicator)[0].filteredValues;

                // console.log('data temp', dataTemp);

                var dataForExport = JSON.parse(JSON.stringify(dataTemp));
                // console.log('datafor export condition', dataForExport)
                let graphicTitle = this.parentNode.parentNode.childNodes[1].innerText;
                dataForExport = cleanDataforExport(dataForExport, 'condition', indicator, time_periods, tObj);


                var chart_link = this.parentNode.nextElementSibling; 

                d3.select(chart_link)
                    .selectAll("a.downloadLink")
                    .on('mouseover', (d) => {
                        // var link = this.parentNode.nextElementSibling;
                        d3.select(chart_link).select('a.downloadLink')
                            .attr('href', `${currTitle}_Condition_Estimates_` +
                            indicator + "_National.csv") //this adds an address that will appear in the lower left corner on Chrome
                            .attr('title', '')  // this removes the "Data Download" tooltip on hover
                    })
                    .on('mouseout', (d) => {
                        d3.select(chart_link).select('a.downloadLink')
                        .attr('title', "Data Download"); // this replaces the "Data Download" title after hover
                    })
                    .on('click', (d) => {
                        var csv_blob = export_data(dataForExport, graphicTitle, null, null, null, 'condition');
                        d3.select(chart_link).select('a.downloadLink')
                            .attr('href', null) //prevent reload on click
                            .style('color', '#5f4c95'); //this applies the visited color. For some reason, this wasn't working in css.
                            
                        let downloadTitle = survey_dict[curr_survey]["currentDownloadTitle"].replace("Indicator", indicator);
                        downloadTitle = downloadTitle.replace(/ /g, "-");
                        console.log(downloadTitle);
                        saveAs(csv_blob, downloadTitle + ".csv");
                    });
            }
        }); //end of container elements.each    

        // Create the root SVG elements.
        var chartWrappers = containerElements
            .append("div")
            .attr("class", "graphic-wrapper");


        var chartElements = chartWrappers.selectAll('svg')
            .data(function (d) {
                var indicator = d3.select(this.closest(".conditionChartContainer")).attr("id");
                // console.log('indicator', indicator)
                var data = sortedData.filter(d => d.key == indicator);
                // console.log('data', data[0])

                return data;
            })
            .enter()
            .append("svg");

        chartElements.each(function (d) {

              
            var chartContainer = d3.select(this);

            // chartDiv = this.closest('.chartDiv')
            chartDiv = d3.select(chartContainer.node().closest('.chartDiv .conditionChart'));
            
            //update chart alt text with correct indicator name and year
            let indicator = d3.select(this.closest(".conditionChartContainer")).attr("id");
            chartDiv.attr("alt", `Graph of ${survey_dict[curr_survey].latest_year} ${indicator} Condition`);

            
            numRows = d.filteredValues.length;
            chartHeight = (barHeight + barGap) * numRows;

            chart = chartContainer
                .attr("width", chartWidth + margins.left + margins.right)
                .attr("height", chartHeight)
                .attr("overflow", "visible")
                .append("g")
                .attr("transform", `translate(${margins.left},${margins.top})`);


            //set dynamically if we want to maximize bar size
            var min = 0;
            var max = 100;

            let y = d3.scaleBand()
                .domain(d3.range(d.filteredValues.length))
                .rangeRound([margins.top, chartHeight])
                .padding(0.1);

            // the y axis labels are wrapped and adjusted at the bottom of this code 
            let yAxis = g => g
                .call(d3.axisLeft(y).tickFormat(i => isLarge.matches ? d.filteredValues[i].CatCondPL : hyphen_dict[d.filteredValues[i].CatCondPL]).tickSizeOuter(0).tickSize(0))
                .call(g => g.select(".domain").remove());

            var xScale = d3
                .scaleLinear()
                .domain([min, max])
                .range([0, chartWidth]);

            // Create D3 axes.
            var xAxis = d3
                .axisBottom()
                .scale(xScale)
                .ticks(ticksX)
                .tickFormat(function (d) {
                    return d.toFixed(0) + "%";
                });

            // Render axes to chart.
            chart
                .append("g")
                .attr("class", "x axis")
                .attr("transform", makeTranslate(0, chartHeight))
                .call(xAxis);

            // Render grid to chart.
            var xAxisGrid = function () {
                return xAxis;
            };

            chart
                .append("g")
                .attr("class", "x grid")
                .attr("transform", makeTranslate(0, chartHeight))
                .call(
                    xAxisGrid()
                    .tickSize(-chartHeight, 0, 0)
                    .tickFormat("")
                );

            chart.append("g")
                .attr("class", "y-axis")
                .call(yAxis);

            //Render bars to chart.
            var bars = chart
                .append("g")
                .attr("class", "bars")
                .selectAll("rect")
                .data(function (d) {
                    return d.filteredValues;
                })
                .enter();

            bars
                .append("rect")
                .attr("x", d => d[valueColumn] >= 0 ? xScale(0) : xScale(d[valueColumn]))
                .attr("width", d => {
                    if (d[valueColumn] != 'NA' && !isNaN(d[valueColumn])) {
                        return Math.abs(xScale(0) - xScale(d[valueColumn]));
                    }
                })
                .attr("y", function (d, i) {
                    //return i * (barHeight + barGap)
                    return y(i);
                })
                .attr("height", y.bandwidth())
                .attr("class", d => `bar ${classify(d.CatCondColor)}`)
                .attr("id", d => `${classify(d[labelColumn])}`);

            //render confidence intervals
            bars
                .append('rect')
                .attr('class', (d, i) => `range ${classify(d.CatCondColor)}`)
                .attr('x', d => xScale(d[startRangeColumn]))
                .attr('width', d => Math.abs(xScale(d[endRangeColumn] - d[startRangeColumn])) ? Math.abs(xScale(d[endRangeColumn] - d[startRangeColumn])) : 0)
                .attr('y', function (d, i) {
                    // return i * (barHeight + barGap) + barHeight * 0.4
                    return y(i) + (y.bandwidth() / 2) - ((barHeight / 8) / 2);
                })
                .attr('height', barHeight / 10)
                .attr("id", d => `${classify(d[labelColumn])}`);



            // Render bar values.
            chart
                .append("g")
                .attr("class", "value")
                .selectAll("text")
                .data(function (d) {
                    return d.filteredValues;
                })
                .enter()
                .append("text")
                .attr("class", d => `label`)
                .attr("id", d => `${classify(d[labelColumn])}`)
                .text(function (d) {
                    var value = Number(d[valueColumn]);
                    if (value > 0 && value < 1 && value > 0.5) {
                        return "1%";
                    } else if (value > 0 && value < 0.5) {
                            return "<1%";
                    } else {
                        return value.toFixed(0) + "%";
                    }
                })
                .attr("x", d => {
                    if (d[endRangeColumn] - d[startRangeColumn]) {
                        return xScale(d[valueColumn]) + xScale((d[endRangeColumn] - d[startRangeColumn]) / 2) + 6;
                    } else {
                        return xScale(d[valueColumn]);
                    }
                })
                .attr("y", function (d, i) {
                    // return i * (barHeight + barGap)
                    let data_label_line_height = 1.4;
                    return y(i) + y.bandwidth() / 2 + ((parseFloat(d3.select(this).style("font-size")) * (data_label_line_height / 2)) / 2.0);
                })
                .attr("transform", (d)=>{ //0 and 100% values need to be moved over a smidge
                    if (d[valueColumn] == 0 || d[valueColumn] == 100){
                        return "translate(5, 0)";
                    } 
                });


            //////add annotations//////////

            //add arrow marker
            chart.append("defs").html(`<marker id="arrow" viewBox="0 0 10 10" refX="5" refY="5"
            markerWidth="6" markerHeight="6"
            orient="auto-start-reverse">
          <path fill="#58595B" d="M 0 0 L 10 5 L 0 10 z" />
            </marker>`);

            //check and add annotations
            var annotationGroups = chart
                .filter(function (d) {
                    var annotationPresent = !d3.select(this.closest(".conditionChart")).select(".annotation").empty();
                    return annotationPresent;
                })
                .append("g")
                .attr("class", "annotationGroup")
                .attr("id", function (d) {
                    var annotation = d3.select(this.closest(".conditionChart")).select(".annotation").attr("id");
                    return classify(annotation);
                })
                .append("path")
                .attr('shape-rendering', 'crispEdges')
                .attr("d", function (d) {
                    var lineCoords = [];
                    var annotationValue = classify(d3.select(this.closest(".conditionChart")).select(".annotation").attr("id"));
                    replaceDataValue(this, DATA);
                    var line_buffer = 20;

                    var target = d3.select(this.closest(".conditionChart")).select(`.label#${annotationValue}`);
                    // console.log('target in cond', target)
                    var targetCoords = [Number(target.attr("x")) + target.node().getComputedTextLength() + 10, Number(target.attr("y")) - (line_buffer / 4.0)];
                    // console.log('target coords', targetCoords)
                    //to get intermediate X, we need to get max x value of target or labels below
                    var targetGroup = d3.select(this.closest(".conditionChart")).selectAll(`.label`);
                    // console.log('target group', targetGroup.data());
                    var targetIndex = targetGroup.data().findIndex(bar => classify(bar[labelColumn]) == annotationValue);
                    // console.log('targetIndex', targetIndex)
                    var belowIndex = targetGroup.filter((d, i) => i >= targetIndex);
                    // console.log('beolowIndex', belowIndex)

                    var belowValues = [];
                    belowIndex.each(function (d, i) {
                        var x = Number(d3.select(this).attr("x"));
                        var dx = Number(d3.select(this).attr("dx"));
                        var textWidth = this.getComputedTextLength();
                        var rightX = x + textWidth + dx;
                        belowValues.push(rightX);
                    });
                    var maxX = Math.max(...belowValues);

                    var intermediateX = maxX + 15;

                    var intermediateCoords = [intermediateX, targetCoords[1]];
                    //30 is graphic container margin-bottom
                    var endCoords = [intermediateCoords[0], chartHeight + margins.bottom + line_buffer];

                    lineCoords.push(endCoords, intermediateCoords, targetCoords);
                    return line(lineCoords);
                })
                .attr("class", "annotationLine")
                .attr("marker-end", "url(#arrow)");

            // Pull the appropriate data for the current chart in order to update the title/tooltip.
            const conditionChartDiv = this.parentNode.parentNode.parentNode;
            const year = this.parentNode.parentNode.parentNode.previousElementSibling.previousElementSibling.innerText.match(/\(([^()]*)\)$/)[1];
            const data = d.filteredValues;

            // loop through the array of objects and create a new array containing the category condition plain language
            let ccpl = [];
            data.forEach(function (d) {
                ccpl.push(`"${d.CatCondPL}"`);
            });
            ccpl = ccpl.filter((c) => c !== `"Not Assessed"`);
            if(ccpl.length < 3){
                ccpl = ccpl.join(' and ');
            }else{
                ccpl = ccpl.join(', ').replace(/,(?=[^,]*$)/, ', and');
            }
            
            // console.log('ccpl: ', ccpl);
        
            let annotationText; 
            if(this.parentNode.parentNode.nextElementSibling){
                annotationText = this.parentNode.parentNode.nextElementSibling.innerText;
            }

            // set the title attribute of the chart using the information above
            annotationText ? 
            conditionChartDiv.setAttribute(
                "title",
                `Bar graph of ${d.key} in ${year} showing ${ccpl} condition, as well as percentage not assessed. ${annotationText}`
              ) :
              conditionChartDiv.setAttribute(
                "title",
                `Bar graph of ${d.key} in ${year} showing ${ccpl} condition, as well as percentage not assessed.`
              )
        });

        /// D3-wrap takes the text and adds it to a div within a Foreign object
        //create the wrap for the line labels
        let wrap = d3.textwrap().bounds({
            width: labelWidth,
            height: labelHeight
        }).padding(labelPadding);

        //this section instigates the wrapping and then shifts things around so that they're centered correctly.
        d3.selectAll('.conditionChartContainer .y-axis .tick text').call(wrap);

        // locate the foreign object
        d3.selectAll('.conditionChartContainer .y-axis .tick foreignObject')
            .style('transform', 'translate(-' + (labelWidth + labelPadding) + 'px, -' + (labelHeight + labelPadding * 2) / 2.0 + 'px)')
            .style('text-align', 'right');

        // size and locate the inner div
        d3.selectAll('.conditionChartContainer .y-axis .tick foreignObject div')
            .style('width', labelWidth + 'px')
            .style('height', labelHeight + 'px')
            .style('display', 'table-cell')
            .style('vertical-align', 'middle');

    });
}

renderConditionGraphic();

function replaceDataValue(element, DATA) {
    var condition = d3.select(element.closest(".conditionChart")).select(".annotation").attr("key");
    var indicator = d3.select(element.closest(".conditionChartContainer")).attr("id");
    var dataValue = DATA.filter(r => r.IndicatorPL == indicator && r.CatCondPL == condition)[0];
    valueColumn = Object.keys(dataValue).includes('Est.P.T3.Cond') ? 'Est.P.T3.Cond' : 'Est.P.T2.Cond';
    if (dataValue) {
        d3.select(element.closest(".conditionChart"))
            .select("span.dataValue")
            .html(`${Number(dataValue[valueColumn]).toFixed(0)}%`);
    }
}